<div class="p-2">
  <mat-card>
    <mat-card-content>
      <h5>Theme Name</h5>
      <div>
        <mat-radio-group
          aria-label="Select a theme"
          [(ngModel)]="themeName"
          color="primary"
        >
          @for (option of themeOptions(); track option) {
            <mat-radio-button class="d-block" [value]="option.value">{{
              option.view
            }}</mat-radio-button>
          }
        </mat-radio-group>
      </div>
    </mat-card-content>
  </mat-card>
</div>
